export const getAppNameFromDomain = (domain: string): string => {
  if (!domain) return '';

  const hostname = domain
    .replace(/^https?:\/\//, '')
    .split('/')[0]
    .split(':')[0]
    .replace(/^www\./, '');

  return hostname.split('.')[0];
};
